import Component from '@glimmer/component';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import t from 'ember-intl/helpers/t';
import AlertBanner from 'tio-ui/components/alert-banner';
import { Section } from 'tio-ui/components/layout';
import type { LoanSummary } from 'tio-common/types/loan-summary';
import type { RecommendationExtension as RecommendationModel } from 'tio-data/data/resources/recommendation.ext';
import type { UserExtension as UserModel } from 'tio-data/data/resources/user.ext';
import type { Sf0726NsldsPrefill } from 'tio-employee/utils/forgiveness-estimator-0726';
import ForgivenessEstimator0726Form from 'tio-employee/components/forgiveness-estimator-0726/form';

interface S {
  Args: {
    model: {
      loanSummary: LoanSummary;
      user: UserModel;
      nsldsPrefill: Sf0726NsldsPrefill | null;
    };
  };
}

export default class PslfDashboardForgivenessEstimatorIndex extends Component<S> {
  @service declare router: RouterService;

  get hasLoans() {
    return (this.args.model.loanSummary.summaryByLoanType || []).length > 0;
  }

  /**
   * Open the saved recommendation through the results route's loading hook.
   * @param recommendation Persisted result returned by the questionnaire.
   * @returns Nothing; starts a route transition.
   */
  didSave = (recommendation: RecommendationModel) => {
    this.router.transitionTo(
      'authenticated.pslf.dashboard.forgiveness-estimator.results',
      recommendation.id
    );
  };

  <template>
    <Section>
      <:header>{{t "forgiveness_estimator_0726.title"}}</:header>
      <:body>
        <p class="text-sm mb-4">{{t "forgiveness_estimator_0726.subtitle"}}</p>
        {{#if this.hasLoans}}
          <ForgivenessEstimator0726Form
            @user={{@model.user}}
            @loanSummary={{@model.loanSummary}}
            @nsldsPrefill={{@model.nsldsPrefill}}
            @didSave={{this.didSave}}
            class="md:max-w-3xl"
          />
        {{else}}
          <AlertBanner @intent="warning" data-test-fe-0726-no-loans>
            <p class="text-sm">{{t "forgiveness_estimator_0726.no_loans"}}</p>
          </AlertBanner>
        {{/if}}
      </:body>
    </Section>
  </template>
}
